import React, { useEffect, useState } from 'react';
import './QualifierInfo.css';

const About = () => {


  return (
    <div className="qualifier-container">
      <h1>QUALIFIERS EXAMS INFORMATION</h1>

    </div>
  );
};

export default About;
